import angular from 'angular';

export const FluxoAprovacoesListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider): void {
        $stateProvider
            .state('meurh_fluxo_aprovacoes', {
            url: '/fluxoaprovacoes?tab',
            template: require('html-loader!./index/fluxoaprovacoes.index.html'),
            controller: 'FluxoAprovacoesIndexController',
            controllerAs: 'fxavcs_cntrllr',
        });
    }
];
